import { CustomDialog, CustomDialogProps } from "components/dialogs/Dialogs";
import { HistoryEntity } from "__generated__/enums";
import EntityChangeHistory from "../../EntityChangeHistory";
import { useTheme } from "@mui/material";
import { EntityHistoryType } from "components/entityHistory/utils/entityHistory.utils";
import EntitySnapshotHistory from "components/entityHistory/EntitySnapshotHistory";

export type EntityHistoryDialogProps = {
	entity: HistoryEntity;
	entityId: number;
	type?: EntityHistoryType;
} & Omit<CustomDialogProps, "children" | "actions" | "dialogStyling">;

const EntityHistoryDialog = ({
	entity,
	entityId,
	type = EntityHistoryType.Relative,
	...rest
}: EntityHistoryDialogProps) => {

	const theme = useTheme();

	return (
		<CustomDialog
			maxWidth="lg"
			{...rest}
			dialogStyling={{
				content: {
					backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#eee",
				},
			}}
		>
			{type === EntityHistoryType.Relative ? (
				<EntityChangeHistory entity={entity} entityId={entityId} />
			) : type === EntityHistoryType.Absolute ? (
				<EntitySnapshotHistory root={entity} rootId={entityId} />
			) : null}
		</CustomDialog>
	);
};

export default EntityHistoryDialog;
